import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { FeatureFlagService } from '@laasy/common-layout';
import { isProfileCompSubmitSession } from 'src/app/modules/auth/auth-constants';
import { ProfileCompletionService } from 'src/app/modules/auth/service/profile-completion.service';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import { MissingInfoModalService } from 'src/app/shared/services/missing-info-modal.service';

@Injectable()
export class ProfileCheckGuard implements CanActivate {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private profileCompletionService: ProfileCompletionService,
    private missingInfoModalService: MissingInfoModalService,
    private featureFlagService: FeatureFlagService
  ) {}

  async canActivate(): Promise<boolean> {
    const currentSession = await this.authenticationService.GetCurrentSession();

    if (currentSession !== null) {
      if(this.featureFlagService.hidePostLoginSurvey) return true;
      const isCompleted = await this.profileCompletionService.authGuardCheckProfileCompletion();
      const isProfileSubmittedOnce = localStorage.getItem(isProfileCompSubmitSession.key) === 'true';
      if (!isCompleted && !this.profileCompletionService.isSkipable && !isProfileSubmittedOnce) {
        this.profileCompletionService.callProfileCompletion = true;
        this.missingInfoModalService.forcedProfileCompletion = true;

      }
    }
    return true;
  }
}
